import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    edit: Palette['primary'];
    purple: Palette['primary'];
  }
  interface PaletteOptions {
    edit?: PaletteOptions['primary'];
    purple?: PaletteOptions['primary'];
  }
}
declare module '@mui/material/IconButton' {
  interface IconButtonPropsColorOverrides {
    edit: true;
  }
}

export const theme = createTheme({
  palette: {
    edit: {
      main: '#009d00',
      light: '#00a006',
    },
    purple: { main: '#8743FF' },
  },
  components: {
    MuiFilledInput: {
      styleOverrides: {
        input: {
          '&:-internal-autofill-selected ': {
            borderRadius: '14px',
          },
        },
        underline: {
          '&&&:before': {
            borderBottom: 'none',
          },
          '&&:after': {
            borderBottom: 'none',
          },
        },
        root: {
          backgroundColor: 'rgba(0, 0, 0, 0.03)',
          borderRadius: '14px',
        },
      },
    },

    MuiButton: {
      variants: [
        {
          props: { color: 'primary' },
          style: {
            background: 'linear-gradient(270deg, #8743FF 0%, #4136F1 100%)',
            boxShadow: '0px 15px 30px 0px rgba(20, 102, 204, 0.16) !important',
            borderRadius: '16px',
          },
        },
        {
          props: { color: 'secondary' },
          style: {
            background: 'rgba(0, 160, 6, 1)',
            border: '1px solid rgba(0, 186, 6, 1)',
            boxShadow: '0px 15px 30px 0px rgba(20, 102, 204, 0.16) !important',
            borderRadius: '16px',
          },
        },
      ],
    },
    MuiPaper: {
      styleOverrides: {
        elevation1: {
          borderRadius: '32px',
        },
      },
    },
  },
});
